export default "__VITE_ASSET__BQURyO0j__"